export const GET_INVESTOR_DECK_ATTEMPT = 'GET_INVESTOR_DECK_ATTEMPT';
export type GET_INVESTOR_DECK_ATTEMPT = typeof GET_INVESTOR_DECK_ATTEMPT;

export const GET_INVESTOR_DECK_SUCCESS = 'GET_INVESTOR_DECK_SUCCESS';
export type GET_INVESTOR_DECK_SUCCESS = typeof GET_INVESTOR_DECK_SUCCESS;

export const GET_INVESTOR_DECK_FAILURE = 'GET_INVESTOR_DECK_FAILURE';
export type GET_INVESTOR_DECK_FAILURE = typeof GET_INVESTOR_DECK_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investor-deck/get/Types.tsx